import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { SubscriptionPaypalButtons } from './subscriptionPaypalButtons';

const PaypalComponentContainer = styled.div`
  height: 55px;
  width: 100%;
  overflow: hidden;
  border-radius: 5px;
`;

const Paypal: FC = () => {
  return (
    <PaypalComponentContainer>
      <SubscriptionPaypalButtons />
    </PaypalComponentContainer>
  );
};

export default memo(Paypal);
